if (!customElements.get("garan-label-modal")) {
  class GaranLabelModal extends HTMLElement {
    connectedCallback() {
      this.svgSrc = this.dataset.svgSrc;
      this.duration = this.dataset.duration;
      this.sku = this.dataset.sku;
      this.trigger = document.querySelector(
        'a[href="#' + this.querySelector("[data-modal]").id + '"]'
      );
      this.target = this.querySelector("[data-garan-label-target]");
      this.loaded = false;

      this.handleTriggerClick = this.handleTriggerClick.bind(this);

      if (this.trigger) {
        this.trigger.addEventListener("click", this.handleTriggerClick);
      }
    }

    disconnectedCallback() {
      if (this.trigger) {
        this.trigger.removeEventListener("click", this.handleTriggerClick);
      }
    }

    handleTriggerClick() {
      if (this.loaded || !this.svgSrc || !this.target) return;
      this.loaded = true;
      this.loadLabel();
    }

    loadLabel() {
      fetch(this.svgSrc)
        .then((response) => {
          if (!response.ok) throw new Error("Fetch failed");
          return response.text();
        })
        .then((svgText) => this.renderLabel(svgText))
        .catch((error) => {
          this.loaded = false;
          if (window.Woolman?.Utils?.debugMode) {
            console.warn("garan-label-modal: unable to load label svg", error);
          }
        });
    }

    renderLabel(svgText) {
      const svgDoc = new DOMParser().parseFromString(svgText, "image/svg+xml");

      if (svgDoc.querySelector("parsererror")) {
        throw new Error("Invalid svg markup");
      }

      const svgRoot = svgDoc.documentElement;

      const warrantyYears = svgDoc.getElementById("warranty-years");
      if (warrantyYears && this.duration) {
        warrantyYears.textContent = this.duration;
      }

      const modelIdentifier = svgDoc.getElementById("model-identifier");
      if (modelIdentifier && this.sku) {
        modelIdentifier.textContent = this.sku;
      }

      // Le SVG embarque ses propres classes/ids (export Illustrator du type
      // .cls-1, .cls-2...) qui entreraient en collision avec celles, non
      // scopées, de lavafields_garan-badge.svg déjà inliné dans la page.
      // Le Shadow DOM isole totalement son <style> dans les deux sens.
      if (!this.target.shadowRoot) {
        this.target.attachShadow({ mode: "open" });
      }

      const style = document.createElement("style");
      style.textContent = "svg { display: block; width: 100%; height: auto; }";

      this.target.shadowRoot.replaceChildren(style, svgRoot);
    }
  }

  customElements.define("garan-label-modal", GaranLabelModal);
}
